import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Rect,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Rect, { width: "6", height: "10", x: "9", y: "7", rx: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M4 22V2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 22V2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "AlignHorizontalSpaceAround";
const AlignHorizontalSpaceAround = memo(themed(Icon));
export {
  AlignHorizontalSpaceAround
};
//# sourceMappingURL=align-horizontal-space-around.js.map
